import React from 'react';

import { PlusIcon, DecrementIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import palette from '@utils/theme/palette';
import Tooltip from '@components/ui/Tooltip/next';
import { useDevice } from '@contexts/device';

import {
  CounterButton,
  CounterButtonLabel,
  StyledCounter,
  TourIncrementButtonWrapper,
} from './CounterStyle';
import { CounterProps } from './CounterInterface';

const Counter = ({
  count = 0,
  min = 0,
  max = 0,
  handleIncrement = () => false,
  handleDecrement = () => false,
  disabledDecrement = false,
  disabledIncrement = false,
  isTour = false,
  children,
}: CounterProps) => {
  const { isDesktop } = useDevice();
  return (
    <StyledCounter>
      <CounterButton
        data-testid='decrement-button'
        disabled={disabledDecrement || count <= min}
        onClick={handleDecrement}
        type='button'
      >
        <CustomIcon
          icon={DecrementIcon}
          fontSize={24}
          paletteColor='darkGrey'
        />
      </CounterButton>
      <CounterButtonLabel data-testid='count-label'>
        {children || count}
      </CounterButtonLabel>
      {isTour && disabledIncrement ? (
        <Tooltip
          overlayInnerStyle={{
            backgroundColor: palette.white,
            color: palette.darkGray,
            lineHeight: 1.43,
            width: '245px',
            boxShadow: ' 0px 0px 20px rgba(58, 58, 58, 0.15)',
            borderRadius: '3px',
            fontSize: '14px',
          }}
          placement={isDesktop ? 'top' : 'topRight'}
          title='Tur en fazla 3 kişi alınabilmektedir.'
        >
          <TourIncrementButtonWrapper>
            <CounterButton
              type='button'
              data-testid='increment-button'
              disabled={disabledIncrement}
              onClick={handleIncrement}
            >
              <CustomIcon
                icon={PlusIcon}
                fontSize={24}
                paletteColor='darkGrey'
              />
            </CounterButton>
          </TourIncrementButtonWrapper>
        </Tooltip>
      ) : (
        <CounterButton
          type='button'
          data-testid='increment-button'
          disabled={disabledIncrement || (max ? count >= max : false)}
          onClick={handleIncrement}
        >
          <CustomIcon icon={PlusIcon} fontSize={24} paletteColor='darkGrey' />
        </CounterButton>
      )}
    </StyledCounter>
  );
};

export default Counter;
